<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-Loading="isLoadingPage">
        <div slot="body">
          <bita-form ref="form">
              <div slot="body">
                  <div class="row">
                    <bita-datepicker
                        ref="fromdate"
                        type="date"
                        id="fromDate"
                        validation-container-class="col-3"
                        name="from-date"
                        label="از تاریخ"
                        inputClass="form-control"
                        v-model="filters.from"
                    />
                    <bita-datepicker
                        ref="todate"
                        type="date"
                        id="toDate"
                        validation-container-class="col-3"
                        name="to-date"
                        label="تا تاریخ"
                        inputClass="form-control"
                        v-model="filters.to"
                    />
                    <!-- <bita-select
                      ref="userFilterSelect"
                      name="user"
                      label="انتخاب کاربر"
                      validation-container-class="col-3"
                      input-class="form-control"
                      :data-source="users"
                      data-text-field="full_name_phone"
                      data-value-field="id"
                      v-model="filters.user"
                    /> -->
                    <bita-select
                      ref="stateSelect"
                      name="state"
                      label="عنوان پیام"
                      rule=""
                      validation-container-class="col-3"
                      input-class="form-control"
                      :data-source="types"
                      data-text-field="name"
                      data-value-field="slug"
                      v-model="filters.type"
                    />
                    <bita-select
                      ref="stateSelect"
                      name="state"
                      label="وضعیت"
                      rule=""
                      validation-container-class="col-3"
                      input-class="form-control"
                      :data-source="states"
                      data-text-field="name"
                      data-value-field="slug"
                      v-model="filters.state"
                    />
                  </div>
                  <bita-bootbutton
                    type="primary mb-3"
                    title="اعمال فیلتر"
                    btn-width="150px"
                    icon="fa fa-search"
                    @click.native="loadData"
                  />
              </div>
          </bita-form>
          <bita-grid
              ref="grid"
              :is-loading="isLoadingGrid"
              :columns="gridColumns"
              :read-data="readData"
              :hasRow="false"
              :resizable="true"
              :grid-server-side="false"
              :batch="true"
              :has-row-number="false"
          />
        </div>
      </bita-ibox>
    </div>
  </div>
</template>
<script>
export default {
    data() {
        return {
            breadCrumbs: [
              {title: "صفحه اصلی", link: "/"},
              {title: "گزارش نوتیفیکیشن", link: "/notifications/report"},
            ],
            isLoadingPage: false,
            isLoadingGrid: false,
            filters: {},
            users: {},
            types: {},
            states: {},
        }
    },
    computed: {
      gridColumns(){
        return [
          { title: "#", template: this.$getTemplate, width: "40px" },
          { field: "UUID", title: "کد پیگیری", template: (e) => (e.UUID ? e.UUID : '-')},
          { field: "full_name", title: "کاربر", template: (e) => (e.name || e.family ? `${e.family} ${e.name}` : "-")},
          { field: "state", title: "وضعیت", template: (e) => (e.state && e.notification_log_state ? e.notification_log_state : "-")},
          { field: "type", title: "عنوان نوتیفیکیشن", template: (e) => (e.notification_type ? e.notification_type : "-")},
          { field: "send_via", title: "ارسال از طریق", template: (e) => (e.send_via ? e.send_via : "-")},
          { field: "created_at", title: "زمان ارسال", template: (e) => (e.created_at ? this.$getJalaliDateTime(e.created_at) : "-")},
        ]
      }
    },
    mounted(){
      Promise.all([
        this.getUsers(),
        this.getStates(),
        this.getTypes(),
      ]).then((res) => {
        this.users = res[0].data;
        this.states = res[1].data;
        this.types = res[2].data;
      });
    },
    methods: {
      getUsers() {
        return this.$persistClient("get", "users?filter[type]=Driver");
      },
      getStates() {
        return this.$persistClient("get", "states?type=notification_log_state");
      },
      getTypes() {
        return this.$persistClient("get", "states?type=notification_type");
      },
      readData(e) {
        let url = this.$makeQueryString("notifications", this.filters);
        this.$persistClient("get", url)
        .then((res) => {
          e.success(res.data);
        })
      },
      loadData() {
      this.$refs.grid.loadDataSource();
      },
    }
}
</script>